import { useQuerySnackbar } from '@explorer/hooks';
import { JumboGetintegrationsGetIntegrationsResponse } from '@explorer/open-api-client';
import { useV1APIQuery } from '@explorer/query';

export const useQueryIntegrations = (params: { client_id: string }) => {
  const { client_id } = params;
  const { snackError } = useQuerySnackbar();

  return useV1APIQuery<JumboGetintegrationsGetIntegrationsResponse>({
    queryKey: ['v1IntegrationsWebAdminIntegrationsGet', client_id],
    queryFn: (client, { signal }) => {
      return client.v1IntegrationsWebAdminIntegrationsGet({ signal } as any);
    },
    explorerAPIOptions: {
      clientId: client_id,
      onError: (error) => {
        snackError('Failed to get integrations.', error.error);
      },
    },
    retry: false,
    enabled: !!client_id,
    refetchOnWindowFocus: false,
  });
};
